import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import RtlLayout from "layouts/rtl";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import PerformanceKPILayout from "layouts/performanceKPI";
import FarmersRegistration from "views/FarmersRegistration";
import AgentRegistration from "views/AgentRegistration";
import RCNCalculator from "views/Public/RCNCalculator";
import ProtectedRoutePerformanceKPI from "components/ProtectedRoutePerformanceKPI";
import SignInPerformanceKPI from "views/auth/SignInPerformanceKPI";

const App = () => {
  return (
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route path="admin/*" element={<AdminLayout />} />
      <Route path="performance-kpi/login" element={<SignInPerformanceKPI />} />
      <Route
        path="performance-kpi/*"
        element={
          <ProtectedRoutePerformanceKPI>
            <PerformanceKPILayout />
          </ProtectedRoutePerformanceKPI>
        }
      />
      <Route path="rtl/*" element={<RtlLayout />} />
      <Route path="/farmers-registration" element={<FarmersRegistration />} />
      <Route path="/rcn-calculator" element={<RCNCalculator />} />
      <Route path="/production-simulator" element={<RCNCalculator />} />
      <Route path="/agents-registration" element={<AgentRegistration />} />
      <Route path="/" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
};

export default App;
